import {action, observable} from "mobx";
import axios from "axios";
import config from "../config";
import {projects} from '../projectsList';

class Projects {
  @observable isLoaded = true;

  @observable projects = [];

  @observable user = {
    name: null,
    id: null
  };

  @action getProjects(cb) {
    this.projects = projects.filter(project => project.type === config.type);
  }

  @action deleteProject(id) {
    axios.delete("/api/projects", { data: { id } }).then(() => {
      this.projects = this.projects.filter(project => project._id !== id);
    });
  }

  constructor() {
    this.getProjects(error => {
      if (error) {
        console.log("Error:", error);
      }
    });
  }
}

export default new Projects();



// WEBPACK FOOTER //
// ./src/stores/projects.js